import { render, staticRenderFns } from "./personMsg.vue?vue&type=template&id=e0108e4a&scoped=true&"
import script from "./personMsg.vue?vue&type=script&lang=js&"
export * from "./personMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0108e4a",
  null
  
)

export default component.exports